import { FC, useEffect } from 'react'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router'
import { checkIsActive, KTIcon, WithChildren } from '../../../../helpers'
import { useLayout } from '../../../core'
import { t } from 'i18next';
import CustomizeTooltip from '../../../../../common/CustomizeTooltip'
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks'
import { getValueFromResource } from '../../../../../common/timeLiveFunction'
import { setPageId } from '../../../../../common/GlobalSlice'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  onClick?: () => void;
  pageId?: string,
}

const SidebarMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
  onClick,
  pageId,
}) => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation()
  const isActive = checkIsActive(pathname, to)
  const { config } = useLayout()
  const { app } = config
  const { showSubMenus, showAdminPages } = useAppSelector((state) => state.globalState);
  const selectedPageId = useAppSelector((state) => state.globalState.pageId);
  const licenseExpireFlag = localStorage.getItem("IsLicenseExpired");
  const IsFreeLicenseExpired = localStorage.getItem("IsFreeLicenseExpired");
  const expireFalg = (licenseExpireFlag === "true" || IsFreeLicenseExpired === "true");
  // const isActiveFlag = pageId && selectedPageId && pageId === selectedPageId;

  const isActiveFlag =
    (pageId && selectedPageId && pageId === selectedPageId) ||
    expireFalg == false && checkIsActive(pathname, to);

  useEffect(() => {
    if (isActiveFlag && pageId && pageId !== selectedPageId) {
      dispatch(setPageId(pageId));
    }
  }, [isActiveFlag, pageId, selectedPageId, dispatch]);

  return (
    <div className='menu-item'>
      <Link className={clsx('menu-link without-sub', { active: isActiveFlag })} to={to} onClick={onClick}>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
          <span className='menu-icon'>
            {' '}
            {showSubMenus ? (
              <CustomizeTooltip content={title} position="right">
                <KTIcon iconName={icon} className='fs-2 text-gray-600' />
              </CustomizeTooltip>
            ) : pageId === "509" ? (
              <div style={{transform:  'rotate(90deg)'}}>
                <KTIcon iconName={icon} className='fs-2 text-gray-600' />
              </div>
            ) : (
              <KTIcon iconName={icon} className='fs-2 text-gray-600' />
            )}

          </span>
        )}
        {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
          <i className={clsx('bi fs-3 text-muted ', fontIcon)}></i>
        )}
        <span className='menu-title'>{getValueFromResource(`${title}`, dispatch, t)}
          {(pageId === "508" || pageId === "509") && (
            <span className="badge badge-sm badge-light-primary ms-1 mb-2 d-inline-flex align-items-center justify-content-center" style={{ fontSize: '8px', lineHeight: '1', padding: '4px 6px' }}>NEW</span>
          )}
        </span>
        {/* <span className='menu-title'>{t(title)}</span> */}
      </Link>
      {children}
    </div>
  )
}

export { SidebarMenuItem }